import { OverChargeClaimsTypes } from './OverChargeTypes';

export const setClaimsOverChargeFilters = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.SET_OVERCHARGE_FILTERS,
  };
};
export const setOverChargeClaimEditActiveKey = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.SET_OVERCHARGE_CLAIM_EDIT_ACTIVE_KEY,
  };
};

export const setOverChargeClaimsEditDrawer = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.SET_OVERCHARGE_EDIT_DRAWER,
  };
};

export const setSelectedOverChargeClaims = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.SET_SELECTED_OVERCHARGE_CLAIMS,
  };
};

export const updateOverChargeClaimInProgress = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.UPDATE_OVERCHARGE_CLAIM_PROGRESS,
  };
};

export const getOverChargeItemsFromExcelInProgress = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_PROGRESS,
  };
};
export const getOverChargeItemsFromExcelInSuccess = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_SUCCESS,
  };
};
export const getOverChargeItemsFromExcelInError = (payload) => {
  return {
    payload,
    type: OverChargeClaimsTypes.GET_ITEMS_FROM_EXCEL_ERROR,
  };
};

export const setOCClaimViewType = (payload) => ({
  payload,
  type: OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE,
});
export const setOCClaimViewTypeInitial = (payload) => ({
  payload,
  type: OverChargeClaimsTypes.SET_CLAIM_SEARCH_VIEW_TYPE_INITIAL,
});
